import { startCase } from 'lodash'

export const transfromMutationType = (type) => {
  // Structure of "type" is "word::word::word" and we have to take words after second "::"
  const requiredTypeStructure = /\b(.*?)\b::\b(.*?)\b::\b(.*?)\b/g

  const isCorrectTypeStructure = requiredTypeStructure.test(type)

  if (!isCorrectTypeStructure) {
    return ''
  }

  const transformedTypeToCorrectString = type?.replace(
    /\b(.*?)\b::\b(.*?)\b::/g,
    ''
  )
  const transformedTypeToDisplay = startCase(transformedTypeToCorrectString)

  return transformedTypeToDisplay ?? ''
}
